export default __webpack_public_path__ + "static/binance-3686525ab809d843d7747350b6833930.svg";